import { RefObject, useRef } from "react"

const uninitialized = Symbol("uninitialized")

export function useLazyRef<T>(factory: () => T) {
  const ref = useRef<T | typeof uninitialized>(uninitialized)

  // eslint-disable-next-line react-hooks/refs
  if (ref.current === uninitialized) {
    // eslint-disable-next-line react-hooks/refs
    ref.current = factory()
  }

  return ref as RefObject<T>
}
